import { Badge } from "@/components/ui/badge";

const STATUS_STYLES = {
  "Pending Payment": "bg-amber-100 text-amber-700 hover:bg-amber-100",
  "Payment Submitted": "bg-blue-100 text-blue-700 hover:bg-blue-100",
  "Payment Approved": "bg-violet-100 text-violet-700 hover:bg-violet-100",
  "Processing": "bg-indigo-100 text-indigo-700 hover:bg-indigo-100",
  "Ready for Pickup": "bg-cyan-100 text-cyan-700 hover:bg-cyan-100",
  "Shipped": "bg-sky-100 text-sky-700 hover:bg-sky-100",
  "Completed": "bg-emerald-100 text-emerald-700 hover:bg-emerald-100",
  "Cancelled": "bg-red-100 text-red-700 hover:bg-red-100",
  "active": "bg-emerald-100 text-emerald-700 hover:bg-emerald-100",
  "suspended": "bg-red-100 text-red-700 hover:bg-red-100",
  "inactive": "bg-slate-100 text-slate-600 hover:bg-slate-100",
};

export function StatusBadge({ status }) {
  const cls = STATUS_STYLES[status] || "bg-slate-100 text-slate-600 hover:bg-slate-100";
  return (
    <Badge variant="secondary" className={`${cls} border-0 font-medium rounded-full px-2.5`} data-testid={`status-badge`}>
      {status}
    </Badge>
  );
}
